import { paramCase } from 'change-case'
import { FC } from 'react'
import { kuiperClassNames } from '@opallabs/kuiper'
import { DesktopNewsFeed, MobileNewsFeed } from './displays'
import { LinkedInDocumentDisplayProps, LinkedInDocumentProps } from './types'

const displays = {
  default: DesktopNewsFeed,
  desktopNewsFeed: DesktopNewsFeed,
  mobileNewsFeed: MobileNewsFeed,
}

function isValidDisplay(display: string): display is keyof typeof displays {
  return Object.keys(displays).includes(display)
}

export const LinkedInDocument: FC<LinkedInDocumentProps> = ({
  accountImage,
  accountName,
  assets,
  content,
  display,
  documentTitle,
  isPresenting = false,
  onExpandAsset,
  onRemoveAsset,
  readOnly = false,
  scheduledAt,
  timezone,
  updateText,
}) => {
  const RenderDisplay: FC<LinkedInDocumentDisplayProps> = isValidDisplay(
    display
  )
    ? displays[display]
    : displays.default

  const handleContentChange = (value: string) => {
    updateText?.(value, 'content')
  }

  const handleDocumentTitleChange = (value: string) => {
    updateText?.(value, 'document_title')
  }

  return (
    <div
      className={kuiperClassNames(
        'linkedin linkedin-document-post',
        `linkedin-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        assets={assets ?? []}
        content={content || ''}
        documentTitle={documentTitle || ''}
        isPresenting={isPresenting}
        onContentChange={handleContentChange}
        onDocumentTitleChange={handleDocumentTitleChange}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        readOnly={readOnly}
        scheduledAt={scheduledAt}
        timezone={timezone}
      />
    </div>
  )
}
